import styled from "styled-components";
import { BsArrowDown, BsChevronDown } from "react-icons/bs";
import theme from "../../modules/themes";
import backgroundGif from "../../assets/ademars/2_behind_scenes/Reveal_Gif.gif";

export const Wrapper = styled.section`
  min-height: ${window.innerHeight}px;
  background-color:black;
  position:relative
`;

export const BackgroundImage = styled.section`
  height: ${window.innerHeight}px;
  // background-image: url("${backgroundGif}");
  background-size: cover;
  background-position: center;
  position:relative;
  background-color:black:
`

export const Container = styled.section`
  width: 85%;
  margin: auto;
  opacity: 0;
  // position:relative
  background-color:black:
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items:flex-end;
  text-align:right
`;

export const Title = styled.div`
  font-size: 7vw;
  color: ${theme.primaryWhite};
  width: 100%;

  p{
    line-height:1.2
  }
  
  .first{
    margin-top: 50px;
    font-family: walbaumBook-medium;

  }
  .second{
    margin-bottom:10px;
    font-family: walbaumBook-medium;
  }
  
  @media(max-width:430px){
    .first{
      margin-top: 38px;
      font-size: 7.5vw;
    }
    .second{
      margin-bottom:2.5vw;
      font-size: 7.5vw;
    }
  }

  @media(max-width:400px){
    .first{
      margin-top: 58px;
    }
    .second{
      margin-bottom:2.5vw
    }
  }

  @media(max-width:380px){
    .first{
      margin-top: 38px;
      font-size: 7.5vw;
    }
    .second{
      margin-bottom:2.5vw;
      font-size: 7.5vw;
    }
  }

  @media(min-width:60px){
    font-size: 40px;
  }
`;

export const SecondaryTitle = styled.h1`
  font-family: helvetica-neue-extra-light;
  margin: 0 auto;
  font-size: 45px;
  color: #ffffff;
  text-transform: uppercase;
  padding:0;
  line-height:1.1;
  font-weight: 200;

  @media(max-width:460px){
    font-size: 32px;
  }

  @media(max-width:375px){
    font-size: 28px;
  }

  @media(max-width:330px){
    font-size: 26px;
  }

  @media(min-width:500px){
    font-size: 43px;
  }
  
`;

export const DescriptionParagraph = styled.section`
  width: 65%;
  font-size: 18px;
  color: ${theme.primaryWhite};
  margin-top: 2vw;
  overflow: scroll;
  line-height: 1.6;
  margin-top:0px;

  @media(max-width:430px){
    font-size: 15px;
  }
  @media(max-width:400px){
    font-size: 14px;
  }

`;

export const Fall = styled.section`
  min-height: ${window.innerHeight}px;
  width:100%;
  background-color:black;
  position:relative;
  padding-top:10px;

  .fall-image{
    width: 100%;
    margin-bottom: 6.5rem;
    @media(max-width:450px){
      margin-bottom: 3rem
    }
  }

  .fall-image-container{
    width:100%;
    margin 6.9rem auto 2.5rem auto;

    @media(max-width:450px){
      margin 4.9rem auto 2.5rem auto;
    }
  }

  .fall-container{
    width:82%;
    margin: auto;

    &.second{
      padding-top: 1.5rem;
      padding-bottom: 4.5rem;

      @media(max-width: 450px){
        padding-top: 0rem;
        padding-bottom: 2rem;
      }

      @media(min-width: 768px){
        padding-top: 0.8rem;
        padding-bottom: 3rem;
      }
    }
  }

  .player-container{
    margin: 2rem 0 4.5rem 0;
    background-color: black;
    width:100%;
    height: 22rem;
  }

  .book-button{
    width:55%;
    margin: 0 auto 5rem auto;
    display:block;
    height: 60px;
    background-color:white;
    color:black;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: black;
    font-family: helvetica-neue-light;
    @media(max-width:450px){
      font-size: 1.1rem;
      height: 3.5rem;
    }
    @media(max-width:350px){
      margin-top:2rem
    }
  }

  .para-one{
    margin: 1.2rem auto 5rem auto;
    color: white;
    font-size:17px;
    line-height:1.3;

    &.two{
      line-height:1.45;
    }
    .first, .second, .third {
      display: block
    }

    @media(max-width:480px){
      .first, .second, .third {
        display: inline
      }
    }

    @media(max-width:450px){
      margin: 1rem auto 5rem auto;
      &.two{
        margin: 1rem auto 3.5rem 0;
        width: 90%
      }
      .first, .second, .third {
        display: block
      }
      font-size:14px;
    }

    @media(max-width:355px){
      margin: 0.8rem auto 0 auto;
      .first, .second, .third {
        display: inline
      }
    }
  }

  .para-two{
    margin: 1.8rem auto 0 auto;
    color: white;
    font-size:20px;
    line-height:1.2;

    .first, .second, .third {
      display: block
    }

    @media(max-width:480px){
      .first, .second, .third {
        display: inline
      }
    }

    @media(max-width:450px){
      .first, .second, .third {
        display: block
      }
      font-size:11px;
    }

    @media(max-width:355px){
      margin: 0.8rem auto 0 auto;
      .first, .second, .third {
        display: inline
      }
    }
  }
`


export const SecondaryHorizontal = styled.div`
  width: 77px;
  border: 1px solid ${theme.primaryYellow};
  background-color:${theme.primaryYellow};
  margin-top: 10px;

  @media(max-width:450px){
    width: 57px;
    margin-top: 8px;
  }
`;

export const LivelySectionHorizontal =styled.div`
  width: 30%;
  border: 0.5px #d87a3e solid;
  margin: 5px 0;

  @media(max-width:430px){
    width: 25%;
    margin: 4px 0;
    height: 1px;
    background-color:#d87a3e;
    border: 0;
  }

  @media(max-width:380px){
    width: 25%;
    margin: 3px 0;
  }
`


export const ScrollIndicatorSection = styled.section`
  position: absolute;
  width: 100%;
  bottom: 5.9rem;
  left: 0;
  text-align: center;
  `;
  
  export const ScrollIndicatorText = styled.div`
  font-size: 14px;
  font-weight:600;
  color: white;

  @media(max-width:430px){
    font-size: 10px;
  }

`;

export const ScrollIndicatorIcon = styled(BsChevronDown)`
  margin-top: 0.3rem;
  color: white;

  @media(max-width:430px){
    margin-right:0
  }
`;
